import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, removeIgnoreItems } from '../../utils';
import SEO from '../../components/SEO/SEO';
import PagePortalHolder from './PagePortalStyles';
import ListItem from '../../components/ListItem/ListItem';
import {getLabel} from '../../utils';

const PagePortal = (props) => {
	const [content, setContent] = useState([]);
	const [livestreams, setLivestreams] = useState([]);
	const [questionPeriods, setQuestionPeriods] = useState([]);
	const [proceedings, setProceedings] = useState([]);
	const [lastHouseVideos, setLastHouseVideos] = useState([]);
	const [specialBills, setSpecialBills] = useState([]);
	const [committees, setCommittees] = useState([]);
	const [joinCommittees, setJoinCommittees] = useState([]);
	const [headerStyles, setHeaderStyles] = useState([]);
	const [pageThumb, setPageThumb] = useState();
	const pageTitle = content.title ? content.title + " | CPAC.ca" : "CPAC.ca";
	const siteURL = window.location.origin;
	const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageDesc = pageLang === "en" ? "CPAC.ca is your destination for Politics and Public Affairs in Canada." : "CPAC.ca est votre destination pour la politique et les affaires publiques au Canada.";

	useEffect(() => {
		const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

        httpGet(serviceUrl, {url:  props.url, crafterSite: craftConf.site}).subscribe((data) => {
			let fieldNames = ["title_t", "title_over_banner_t", "subtitle_over_banner_t",
				"livestreams.title_t", "livestreams.description_t", "livestreams.image_s", 
				"livestreams.altImageTxt_s", "livestreams.url_s", 
				"livestreams.category_t", "livestreams.categoryURL_s", 
				"questionPeriods;title_t", "questionPeriods;seeAllUrl_s",
				"questionPeriods.title_t", "questionPeriods.description_t", "questionPeriods.image_s", 
				"questionPeriods.altImageTxt_s", "questionPeriods.url_s",
				"questionPeriods.category_t", "questionPeriods.categoryURL_s",
				"proceedings;title_t", "proceedings;seeAllUrl_s",
				"proceedings.title_t", "proceedings.description_t", "proceedings.image_s", 
				"proceedings.altImageTxt_s", "proceedings.url_s",
				"proceedings.category_t", "proceedings.categoryURL_s",
				"lastHouseVideos;title_t", "lastHouseVideos;seeAllUrl_s",
				"lastHouseVideos.title_t", "lastHouseVideos.description_t", "lastHouseVideos.image_s", 
				"lastHouseVideos.altImageTxt_s", "lastHouseVideos.url_s", 
				"lastHouseVideos.category_t", "lastHouseVideos.categoryURL_s", 
				"specialBills;title_t", "specialBills;seeAllUrl_s",
				"specialBills.title_t", "specialBills.description_t", "specialBills.image_s", 
				"specialBills.altImageTxt_s", "specialBills.url_s", 
				"specialBills.category_t", "specialBills.categoryURL_s",
				"committees.name_s", 
				"committees.description_t","committees.url_t",
				"joinCommittees.name_s", 
				"joinCommittees.description_t","joinCommittees.url_t",
				"thumbnailResult.image_s", "thumbnailResult.altImageTxt_s"
			]
			if(data.page.committees && data.page.committees.item && data.page.committees.item.length > 0) {
				data.page.committees.item = removeIgnoreItems(data.page.committees);
			}

			if(data.page.joinCommittees && data.page.joinCommittees.item && data.page.joinCommittees.item.length > 0) {
				data.page.joinCommittees.item = removeIgnoreItems(data.page.joinCommittees);
			}

			languagePicker(data, fieldNames);
			
			let dataPage = data.page;
			setContent(dataPage);
			setLivestreams(dataPage.livestreams);
			setQuestionPeriods(dataPage.questionPeriods);
			setProceedings(dataPage.proceedings);
			setLastHouseVideos(dataPage.lastHouseVideos);
			setSpecialBills(dataPage.specialBills);
			setPageThumb(dataPage.thumbnailResult.item[0].image);

			if(dataPage.header_hex_color_s && dataPage.header_icon_s) {
				setHeaderStyles([dataPage.header_hex_color_s,dataPage.header_icon_s ]);
			}
			if(dataPage.committees && dataPage.committees.item) {
				setCommittees(dataPage.committees.item)
			}
			if(dataPage.joinCommittees && dataPage.joinCommittees.item) {
				setJoinCommittees(dataPage.joinCommittees.item)
			}
			
		});
		
	}, [props.url, props.current_lang]);

	useEffect(()=> {
		props.setCurrentLanguage(props.lan);
	},[props.lan]);

	const renderCommittees = () => {
		return committees.map((committee, index)=>{
			return (
				<li key={`com-${index}`} itemProp='itemListElement'>
					<a href={committee.url} className="committee">
						<div  >
							<div className="color-green" style={{background: `#${headerStyles[0]}` , borderColor: `#${headerStyles[0]}`}} itemProp='name'>{committee.name}</div>
							<p itemProp='description'>{committee.description}</p>
						</div >
					</a>
				</li>
			)
		})
	}

	const renderJoinCommittees = () => {
		return joinCommittees.map((committee, index)=>{
			return (
				<li key={`join-com-${index}`} itemProp='itemListElement'>
					<a href={committee.url} className="committee">
						<div >
							<div className="color-joint" itemProp='name'>{committee.name}</div>
							<p itemProp='description'>{committee.description}</p>
						</div>
					</a>
				</li>
			)
		})
	}
	
	return(
		<>
		<SEO pageDesc={pageDesc} pageURL={pageURL} title={content.title} pageTitle={pageTitle} image={siteURL + pageThumb} pageLocale={pageLocale} />
		<PagePortalHolder>
			<h1 style={{background: `#${headerStyles[0]}`}} tabIndex="0" alt={content.title} itemProp='headline'>
				{headerStyles[1] ? 
				<img src={headerStyles[1]} aria-hidden="true" alt="header-icon"/> : 
				<div className="loading"/>}
				{content.title ? content.title : getLabel("LOADING")}
			</h1>
			<div className="content-wrapper">
				<div className="house-left content__left" itemProp="mainEntity">
						{ livestreams ? <ListItem items={livestreams}/> : <h2>{getLabel("NO_STREAMS_SCHEDULED")}</h2> }
						{ questionPeriods && <ListItem items={questionPeriods}/> }
						{ proceedings && <ListItem items={proceedings}/> }
						{ specialBills && <ListItem items={specialBills}/> }
						{committees.length>0 && 
							<section id="committees" tabIndex="0" aria-label={getLabel("COMMITTEES")}>
								<h2 className="hn__Header">{getLabel("COMMITTEES")}</h2>
								<ul className="committees-container" itemScope itemType='https://schema.org/ItemList'>
									{renderCommittees()}   
								</ul>
							</section>
						}
						{joinCommittees.length>0 &&
							<section id="latest-committees" tabIndex="0" aria-label={getLabel("JOINT_COMMITTEES")}>
								<h2 className="hn__Header">{getLabel("JOINT_COMMITTEES")}</h2>	
								<ul className="committees-container" itemScope itemType='https://schema.org/ItemList'>
									{renderJoinCommittees()}   
								</ul>
							</section>
						}
				</div>
				<aside className="latest-house-videos content__right" itemScope itemType="https://schema.org/WPSideBar">
						{ lastHouseVideos && <ListItem items={lastHouseVideos}/> } 
				</aside>
			</div>
		</PagePortalHolder>
		</>
	)
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
	setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(PagePortal);